export default {
  'get-list': {
    method: 'post',
    url: '/commodity/list'
  },
  add: {
    method: 'post',
    url: '/commodity'
  },
  delete: {
    method: 'delete',
    url: '/commodity'
  },
  update: {
    method: 'put',
    url: '/commodity/ID'
  },
  find: {
    method: 'get',
    url: 'partner/commodity/COOPERATOR/find?key=KEY'
  },
  findByOpportunity: {
    method: 'get',
    url: 'partner/commodity/COOPERATOR/find/OPPORTUNITY?key=KEY'
  }
}
